/* Preserve the theme's variant and subscription controls; refine their presentation. */
(() => {
  const root = document.querySelector('.ff-flavour-refined .main-product__content');
  if (!root) return;
  const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
  const update = () => {
    // Pack totals, prices and the Add to basket label are handled by snippets/ff-bundle-save.liquid (11 Oct 2026).
    // Repeated frequency prices may be hidden only when all choices have the same price.
    const plans = [...root.querySelectorAll('.kaching-subscriptions__selling-plan')];
    const prices = plans.map(p => p.querySelector('.kaching-subscriptions__selling-plan-price')?.textContent.trim());
    const equal = prices.length > 1 && prices.every(p => p && p === prices[0]);
    if (root.classList.contains('ff-equal-plan-prices') !== equal) root.classList.toggle('ff-equal-plan-prices', equal);
    const form = root.querySelector('.xo-product-info-content__buy-form');
    if (form && !form.querySelector('.ff-purchase-review')) {
      // Feature a clear 5-star taste review here; never a service or delivery story.
      const avoid = /problem|issue|courier|deliver|late|delay|damag|broke|leak|missing|refund|wrong|disappoint|sorted|dealt with|customer service|but /i;
      const review = [...document.querySelectorAll('#judgeme_product_reviews .jdgm-rev')].find(r => {
        const text = r.querySelector('.jdgm-rev__body')?.textContent.trim();
        const score = Number(r.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'));
        return text && score === 5 && text.length >= 25 && text.length <= 200 && !avoid.test(text);
      });
      if (review) {
        const box = document.createElement('figure'); box.className = 'ff-purchase-review';
        const quote = document.createElement('blockquote'); quote.textContent = '“' + review.querySelector('.jdgm-rev__body').textContent.trim().replace(/^["“]|["”]$/g, '') + '”';
        const caption = document.createElement('figcaption');
        const author = review.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
        const rating = review.querySelector('.jdgm-rev__rating')?.getAttribute('data-score');
        caption.textContent = author + (rating ? ' · ' + rating + '/5' : '');
        const link = document.createElement('a'); link.href = '#judgeme_product_reviews'; link.textContent = form.dataset.reviewLink;
        box.append(quote, caption, link); form.append(box);
      }
    }
  };
  let pending = false;
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; update(); }); } };
  new MutationObserver(schedule).observe(root, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','checked','data-pack-count','data-container']});
  const reviews = document.getElementById('judgeme_product_reviews');
  if (reviews) new MutationObserver(schedule).observe(reviews, {childList:true,subtree:true});
  root.addEventListener('input', schedule); root.addEventListener('change', schedule);
  root.addEventListener('click', () => setTimeout(schedule, 80));
  update();
})();